/* eslint-disable @typescript-eslint/no-explicit-any */
import { Buffer } from 'buffer';
(window as any).global = window;
(document as any).global = document;
(window as any).Buffer = Buffer;
(window as any).process = {
  env: { DEBUG: undefined },
  version: '',
  nextTick: (fn: (...args: any[]) => void) => setTimeout(fn, 0)
};
/* eslint-enable @typescript-eslint/no-explicit-any */

import { enableProdMode, mergeApplicationConfig } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { environment } from '@vaki/shared/util/environment';
import { appConfig } from './app/config/app.config';
import { browserConfig } from './app/config/app.config.browser';
import { initErrorTrackingBrowser } from './app/core/error-tracking/sentry-browser.init';

// Runs before bootstrap, deliberately not deferred — see
// sentry-browser.init.ts's doc comment for why (this app's own
// feasibility spike found deferring loses exactly the bootstrap errors
// this issue most wants to see).
initErrorTrackingBrowser();

if (environment.production) {
  enableProdMode();
}

const config = mergeApplicationConfig(appConfig, browserConfig);

bootstrapApplication(AppComponent, config).catch((err) =>
  console.error({ err: 'error bootstraping app' + err })
);
